import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/success-girl-2.svg'


const _hoisted_1 = {
  id: "modal-plugin-download-confirmation",
  class: "modal modal-md fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3 pt-5" }
const _hoisted_5 = {
  key: 0,
  class: "fs-6 text-center mt-4"
}
const _hoisted_6 = {
  key: 1,
  class: "fs-6 text-center mt-4"
}
const _hoisted_7 = { class: "modal-footer py-3" }

import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'

  import { ref, onMounted, watch } from 'vue'

  import { useModalControl } from '../store/pinia/useModalControl.store'
  import usePluginExecutionConfirmation from '../composables/usePluginExecutionConfirmationModal'
  import { usePlugin } from '@/store/Pinia/usePlugin.store'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalPluginDownloadConfirmation',
  setup(__props, { expose: __expose }) {

  const modalControlStore = useModalControl()
  const { showPluginExecutionConfirmation, hidePluginExecutionConfirmation } =
    usePluginExecutionConfirmation()

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const hasIssuedAt = ref(false)
  const pluginStore = ref()

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-download-confirmation', {
      backdrop: 'static',
      keyboard: false,
    })

    pluginStore.value = usePlugin()

    hasIssuedAt.value =
      pluginStore.value.certificateIssuedAtWasChecked &&
      pluginStore.value.issuedAt?.trim()?.length > 0
  })

  watch(
    () =>
      pluginStore.value?.certificateIssuedAtWasChecked &&
      pluginStore.value?.issuedAt?.trim()?.length > 0,
    (value) => {
      if (value) {
        hasIssuedAt.value = value
      }
    },
  )

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function proceed() {
    hide()
    modalControlStore.show({
      modalId: 'pluginExecutionConfirmation',
      show: showPluginExecutionConfirmation,
      hide: hidePluginExecutionConfirmation,
    })
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            alt: "sucesso",
            src: _imports_0
          }, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "fs-6 text-center mt-4" }, [
            _createElementVNode("strong", null, "Oba, você baixou o plugin!")
          ], -1)),
          (!hasIssuedAt.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _cache[0] || (_cache[0] = [
                _createTextVNode(" Ele é "),
                _createElementVNode("strong", null, "essencial", -1),
                _createTextVNode(" para a "),
                _createElementVNode("strong", null, "emissão do seu Certificado Digital A1.", -1)
              ])))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, _cache[1] || (_cache[1] = [
                _createTextVNode(" Ele é "),
                _createElementVNode("strong", null, "essencial para baixar o Certificado A1", -1),
                _createTextVNode(" no seu computador. ")
              ])))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: proceed
          }, [
            _cache[4] || (_cache[4] = _createTextVNode(" Avançar ")),
            _createVNode(IconComponent, {
              name: "arrow-right",
              class: "ms-2"
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})